import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "vaccine-status" }
const _hoisted_2 = {
  key: 0,
  class: "status"
}
const _hoisted_3 = {
  key: 1,
  class: "status red big"
}
const _hoisted_4 = {
  key: 2,
  class: "status"
}
const _hoisted_5 = {
  key: 3,
  class: "status"
}
const _hoisted_6 = { class: "big" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "subheading" }, "Vaccinations", -1)),
    (typeof $props.vax === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Not Started"))
      : ($setup.incomplete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Incomplete"))
        : ($setup.expired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "red big" }, "Expired ", -1),
              _createElementVNode("span", null, "Needs Update", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "green big" }, "Valid ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("span", null, "thru ", -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString($setup.expiration), 1)
            ]))
  ]))
}